import { AuthQuery, GetCompanyDetailsQuery } from '../../__generated__/graphql'
import { useCurrentUser } from '../../utils/hooks/useUserContext'
import { useMaybeCurrentCompanyDisplayedContext } from './currentCompanyDisplayedContext'
import { isNil } from 'lodash-es'
import { AdgroupBudgetUserPermissions } from './userPermissions.config'

export type UserPermissions =
  | GetCompanyDetailsQuery['company']['userPermissions']
  | AuthQuery['me']['company']['userPermissions']

export type { AdgroupBudgetUserPermissions, AdgroupCostUserPermissions } from './userPermissions.config'
export {
  ADGROUP_BUDGET_CAPPING_LOCKED_LABEL_KEYS,
  ADGROUP_BUDGET_CAPPING_PERMISSION_KEYS,
  ADGROUP_COST_PERMISSION_KEYS,
} from './userPermissions.config'

export function useUserPermissions(): UserPermissions {
  const companyDetails = useMaybeCurrentCompanyDisplayedContext()
  const user = useCurrentUser()

  if (!isNil(companyDetails)) return companyDetails.company.userPermissions

  return user.me.company.userPermissions
}

export function useAdgroupBudgetUserPermissions(): AdgroupBudgetUserPermissions {
  const {
    adgroupBudgetCapping,
    adgroupMonthlyBudgetCapping,
    adgroupOverallBudgetCapping,
    adgroupOpenBudgetCapping,
    adgroupOpenDailyBudget,
  } = useUserPermissions()

  return {
    adgroupBudgetCapping,
    adgroupMonthlyBudgetCapping,
    adgroupOverallBudgetCapping,
    adgroupOpenBudgetCapping,
    adgroupOpenDailyBudget,
  }
}
